import axios from "axios";
import { create } from "zustand";

const searchTagStore = create((set) => ({
  searchTags: null,

  fetchAllSearchTag: async () => {
    // fetch search tags
    const res = await axios.get("/site/fetch-all-search-tag");
    // set tags to state
    set({ searchTags: res.data.searchTags });
  },
}));

export default searchTagStore;
